import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import { AppDispatch, RootState } from 'redux/store'
import { groupsAPI } from 'redux/api/groupsApi'
import { useGET_groupCoursesQuery } from 'redux/api/groupCoursesApi'
import { clearAllFilters, setSearch } from 'redux/ui/groupCoursesUI'

import PageHeading from 'components/atoms/PageHeading'
import MainTableFiltersForm from 'components/organisms/forms/tableFilters/MainTableFiltersForm'
import MainTable from 'components/organisms/tables/MainTable'
import ExtraFiltersGroupCourses from 'components/organisms/forms/tableFilters/groupCourses/ExtraFilters'

import formModel, { initialValues } from 'utils/tableFilterModels/groupCoursesTableFilterModel'
import { useTableModel } from 'utils/tableModels/useGroupCoursesTableModel'
import { FC, useEffect } from 'react'
import { Button, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { LockClock } from '@mui/icons-material'
import BoxTitle from 'components/atoms/BoxTitle'


interface IProps {
  showButtons?: boolean
}

const GroupCoursesPage:FC<IProps> = ({showButtons = false}) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const dispatch = useDispatch<AppDispatch>()
  
  const reduxKey = 'groupCourses'
  // For Extra filters
  const activeFilters = useSelector((state: RootState) => state[reduxKey].activeFilters)
  const filters = {
    search: useSelector((state: RootState) => state[reduxKey].tableFilters.search),
    group: useSelector((state: RootState) => state[reduxKey].tableFilters.group),
    course: useSelector((state: RootState) => state[reduxKey].tableFilters.course),
    status: useSelector((state: RootState) => state[reduxKey].tableFilters.status),
  }

  const user = useSelector((state: RootState) => state['user'].user)

  useEffect(() => { 
    dispatch(clearAllFilters())
  }, [])


  return (
    <>
      {showButtons 
        ? <div style={{ padding: '20px', paddingBottom: '0px' }}><BoxTitle title={user?.role === 'teacher' ? t('common.my-courses') : t('common.group-courses')} icon={<LockClock/>} /></div>
        : <PageHeading title={user?.role === 'teacher' ? t('common.my-courses') : t('common.group-courses')} /> }


      <MainTable
        useTableModel={useTableModel}
        getTableData={useGET_groupCoursesQuery}
        filters={filters}
        header={
          <div style={{ position: 'relative' }}> 

            <div>
              <MainTableFiltersForm
                reduxKey={reduxKey}
                tag="groups"
                entityName={t('common.group-course')}
                addLabel={t('common.add-group-course')}
                api={groupsAPI}
                setSearch={setSearch}
                searchBarSize={5}
                clearAllFilters={clearAllFilters}
                formModel={formModel}
                initialValues={initialValues}
                activeFilters={activeFilters}
                hideDefaultActions={true}
              >  
                <ExtraFiltersGroupCourses />
              </MainTableFiltersForm>
            </div>
            {showButtons &&
            <div className='my-courses-buttons'>
                <Button size='small'  variant='contained' color='primary' onClick={() => {navigate('/syllabus')}}>
                   <Typography sx={{fontSize:'11px',fontWeight:'600'}}>{`${t('common.program')}`}</Typography>
                </Button>
                <Button size='small'  variant='contained' color='primary' onClick={() => {navigate('/lesson-plans/add')}} >
                  <Typography sx={{fontSize:'11px',fontWeight:'600'}}>{`${t('common.add-lesson-plan')}`}</Typography>
                </Button>
                <Button size='small'  variant='contained' color='primary' onClick={() => {navigate('/courses/add')}}>
                  <Typography sx={{fontSize:'11px',fontWeight:'600'}}>{`${t('common.enroll-course')}`}</Typography>
                </Button>
                <Button size='small'  variant='outlined' color='black' onClick={() => {navigate('/courses')}}>
                  <Typography sx={{fontSize:'11px',fontWeight:'600'}}>{`${t('common.view-all')}`}</Typography>
                </Button>
            </div>}
          </div>
        }
      />
    </>
  )
}
export default GroupCoursesPage
